import getSelectorByFeatureName from '../../utils/redux/getSelectorByFeatureName';

const baseSelector = getSelectorByFeatureName('userDetailsPage');

export default (state) => ({
  ...baseSelector(state),
  ownerPool: state.userDetailsPage.ownerPool,
});
